import { useMemo } from 'react';
import { PageHeader } from '@/components/PageHeader';
import { Banner } from '@/components/Banner';
import { Card } from '@/components/Card';
import { detectarPlataforma } from './platform';

const PASOS_IOS = [
  'Abre esta pagina en Safari. Chrome y Firefox en iPhone no pueden instalar aplicaciones.',
  'Toca el boton de Compartir, el cuadro con la flecha hacia arriba.',
  'Desliza y elige "Agregar a inicio".',
  'Confirma con "Agregar". El icono queda en tu pantalla de inicio.',
  'Abre la aplicacion desde ese icono. A partir de ahi, captura todo desde ahi.',
];

export function InstallHelpPage() {
  const plataforma = useMemo(() => detectarPlataforma(), []);

  return (
    <div className="space-y-5">
      <PageHeader
        titulo="Instalar la aplicacion"
        descripcion="Para usarla sin conexion y proteger tus datos"
      />

      {plataforma.enStandalone && (
        <Banner tono="exito" titulo="Ya estas usando la aplicacion instalada">
          Es el lugar correcto para capturar tu informacion.
        </Banner>
      )}

      {plataforma.esNavegadorSinInstalacionEnIOS && (
        <Banner tono="alerta" titulo="Este navegador no puede instalar la aplicacion">
          En iPhone solo Safari permite agregar aplicaciones a la pantalla de inicio. Abre
          esta misma direccion en Safari.
        </Banner>
      )}

      <Card>
        <h2 className="mb-3 font-semibold text-texto">Pasos en iPhone</h2>
        <ol className="space-y-3">
          {PASOS_IOS.map((paso, indice) => (
            <li key={paso} className="flex gap-3">
              <span
                aria-hidden="true"
                className="flex size-6 shrink-0 items-center justify-center rounded-full bg-marca text-xs font-bold text-white"
              >
                {indice + 1}
              </span>
              <span className="text-sm leading-relaxed text-texto">{paso}</span>
            </li>
          ))}
        </ol>
      </Card>

      <Banner tono="aviso" titulo="Por que importa instalarla">
        <p>
          En iOS la aplicacion instalada guarda sus datos en un lugar distinto al de Safari.
          No se comparten ni se copian entre si.
        </p>
        <p className="mt-2">
          Ademas, Safari puede borrar los datos de sitios que no se usan durante varios
          dias. La aplicacion instalada queda exenta de esa limpieza.
        </p>
      </Banner>

      <Banner tono="alerta" titulo="Tus datos viven solo en este telefono">
        No hay copia en la nube. Si borras los datos de navegacion, cambias de telefono o lo
        pierdes, la unica forma de recuperar tu informacion es un respaldo exportado.
      </Banner>
    </div>
  );
}
